import { BOT_CHANNEL, BOT_CHANNEL_MOBILE } from '../util/Constants';

const getClientContext = (userTrackingId, bankId = 'CB') => {
  try {
    return JSON.stringify({
      client: {
        user_tracking_id: userTrackingId || 'not set',
        app_title: `${bankId} Web`,
        app_package_name: 'n/a',
        app_version_code: 'n/a',
        app_version_name: 'n/a'
      },
      env: {
        platform: navigator.platform,
        platform_version: navigator.appVersion,
        make: navigator.appName,
        locale: navigator.language,
        device_name: navigator.userAgent
      }
    });
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchConfig = async () => {
  const resp = await fetch('/config.json');
  return resp.json();
};

export const setRequestHeadersForAuth2 = (accessToken) => {
  return {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Forwarded-For': '127.0.0.1',
    'x-bpi-client-context': getClientContext(),
    Accept: 'application/json',
    Authorization: `Bearer ${accessToken}`
  };
};

export const generateFormBody = (
  scope = '30',
  grant_type = 'client_credentials',
  oauth_scope = 'psd2payments',
  get_user_info = 'true'
) => {
  var details = {
    scope,
    grant_type,
    oauth_scope,
    get_user_info
  };
  if (window.urlParams.customContext) details.custom_context = window.urlParams.customContext;
  details[BOT_CHANNEL] = BOT_CHANNEL_MOBILE;
  const formBody = Object.keys(details)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(details[key]))
    .join('&');
  return formBody;
};

export const getTokenFromMobile = () => {
  if (window.AndroidInterface) {
    if (window.AndroidInterface.getAuthToken) {
      return window.AndroidInterface.getAuthToken();
    } else {
      throw 'getAuthToken not defined';
    }
  } else if (window.webkit) {
    if (window.getAuthToken) {
      let tokenFromCallback;
      window.getAuthToken((token) => {
        tokenFromCallback = token;
      });
      return tokenFromCallback;
    } else {
      throw 'getAuthToken not defined';
    }
  } else {
    console.log(`No mobile interface detected`);
    return null;
  }
};
